// Executive Challenge — the invite-based, one-season GM contest. This module is
// the single source of truth for the scenario's fixed rules. The seed and team
// are per-challenge (the seed derives from the 6-digit join code, the team from
// the host's pick), so they are NOT here.
//
// Season numbering: the league is built at the latest real state (season 2026,
// AFTER_DRAFT — right after the 2026 draft). The challenge advances into
// RESIGN_PLAYERS still in season 2026; PRESEASON bumps the season to 2027, so
// the contested 2026-27 campaign is season 2027 in game terms, and the contest
// ends entering AFTER_DRAFT of season 2027 — immediately after the 2027 draft.

import { PHASE } from "./constants.ts";

export const EXECUTIVE_SCENARIO = {
	id: "executive-2026",
	name: "Summer 2026 Executive Challenge",
	blurb:
		"One season, one team, frozen luck. Everyone runs the same club through the same injuries and development — only your moves differ. Re-sign, work free agency, trade and draft your way to the top of the board.",
	startSeason: 2026,
	startPhase: PHASE.RESIGN_PLAYERS, // 7
	endSeason: 2027,
	endPhase: PHASE.AFTER_DRAFT, // 6
} as const;

// The world IS the code: everyone who enters a code regenerates the identical
// seeded universe, and restarting can't re-roll luck.
export const seedForCode = (code: string) => `${EXECUTIVE_SCENARIO.id}/${code}`;

// 4-character NBA-Jam-style handle shown on the leaderboard and share card.
export const PLAYER_ID_REGEX = /^[A-Z0-9]{1,4}$/;

export const normalizePlayerId = (raw: string) =>
	raw
		.toUpperCase()
		.replaceAll(/[^A-Z0-9]/g, "")
		.slice(0, 4);

export const isValidPlayerId = (playerId: string) =>
	PLAYER_ID_REGEX.test(playerId);

export const CHALLENGE_CODE_LENGTH = 6;

export const isValidChallengeCode = (code: string) =>
	new RegExp(`^\\d{${CHALLENGE_CODE_LENGTH}}$`).test(code);
